<template>
    <div class="card" >
        <div class="card-head" >
            <div class="type">
                <slot name="type"></slot>
            </div>
            <div class="calender">
                <slot name="calender"></slot>
            </div>
        </div>
        <div class="card-body"  @click="jumpLiveCourse" :style="cardImgStyle">
            <div class="signal" :style="{top: !showHead&&signalTop}">
                <slot name="card-body" ></slot>
            </div>
        </div>
        <div class="card-footer" v-if="showFooter">
            <div class="name">{{name.replace(/#/g, '')}}</div>
            <div class="live-info">
                <div class="live-time">播出时间：{{liveTime.replace(/-/g, '/').slice(0, 16)}}</div>
                <div class="view-num" v-if="showViewNum"><img src="~@/assets/eye.png" alt=""><span>{{viewNum > 9999 ? 9999 : viewNum}}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: '直播课'
            },
            liveTime: {
                type: String,
                default: '2019/12/01 13:00'
            },
            viewNum: {
                type: Number,
                default: 0
            },
            courseId: {
                type: String
            },
            channelId : {
                type: String
            },
            showFooter: {
                type: Boolean,
                default: true
            },
            showViewNum: {
                type: Boolean,
                default: true
            },
            img: {
                type: String
            },
            status: { //状态，直播还是回放 1直播  2回放
                type: Number
            },
            type: { //直播类型，区分早盘点评类与其他课程（详情页不一样） -1 -3为早盘点评类
                type: Number
            },
            padding: {
                type: Boolean,
                default: true
            },
            isFree: {
                type: Boolean,
                default: false
            },
            showHead: {
                type: Boolean,
                default: false
            },
            signalTop: {
                type: String,
                default: '0.24rem'
            },
            noticeId: {
                type: Number
            }
        },
        computed: {
            cardImgStyle() {
                const style = {
                    margin: '0 0.4rem',
                    backgroundPosition : '0 0'
                }
                if (this.img) {
                    style.backgroundImage = `url(${this.img})`;
                }
                if (!this.padding) {
                    style.margin = '4px';
                }
                if (!this.showHead) {
                    style.paddingTop = '0.35rem';
                    style.backgroundPosition = '0 0.35rem';
                }
                return style;
            }
        },
        methods: {
            jumpLiveCourse() {
                if (this.channelId) {
                    this.$router.push({
                        path: "/livecourse",
                        query: { courseId: this.courseId, channelId: this.channelId, status: this.status, type: this.type, free: this.isFree ? 1: 0 }
                    });
                } else {
                    this.$router.push({
                        path: "/livecourse",
                        query: { courseId: this.courseId, noticeId: this.noticeId, status: this.status, type: this.type, free: this.isFree ? 1: 0 }
                    });
                }
            }
        }
    }
</script>

<style scoped>
.card {
    /* margin-bottom: 8px; */
    font-size: 16px;
    text-align: left;
    background: #fff;
}
.card-head {
    display: flex;
    margin: 0 calc(0.4rem - 2px) 0 8px;
    align-items: center;
}
.type {
    flex: 1;
    font-weight: 600;
}
.card-body {
    height: 3.64rem;
    position: relative;
    background-image: url('~@/assets/placeholder.png');
    background-repeat: no-repeat;
    background-position: 0 0.35rem;
    background-size: 100% 100%;
}
.card-footer {
    margin: 0 0.4rem;
}
.signal {
    position: absolute;
    top: 0.24rem;
    left: 0.26rem;
}
.live-info {
    display: flex;
    color: #666666;
}
.live-time {
    flex: 1;
    margin-bottom: 0.14rem;
    font-size: 0.25rem;
    color: #666666;
}
.view-num {
    display: flex;
    align-items: center;
    font-size: 0.25rem;
    width: 0.95rem;
}
.view-num img {
    width: 0.28rem;
    height: 0.18rem;
    margin-right: 4px;
}
.name {
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
}
</style>